import * as React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { StyledAvatar, StyledName, StyledWrap, StyledLabelContainer } from './AvatarList.styles.js';
import IconTooltip from '../IconTooltip/IconTooltip.js';

/* eslint-disable */
const AvatarList = _ref => {
  var _lists$, _lists$slice;
  let {
    lists = [],
    marginLeft = '-6px',
    showNumber = 5,
    plusClick,
    fallbackSrc
  } = _ref;
  if (lists.length == 0) return '-';
  if (lists.length == 1) return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(StyledAvatar, {
    src: lists[0].src,
    marginLeft: 0,
    onError: e => {
      if (e.currentTarget.src !== fallbackSrc) {
        e.currentTarget.src = fallbackSrc;
      }
    }
  }), /*#__PURE__*/React.createElement(StyledName, null, (_lists$ = lists[0]) === null || _lists$ === void 0 ? void 0 : _lists$.label));
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, lists === null || lists === void 0 || (_lists$slice = lists.slice(0, showNumber)) === null || _lists$slice === void 0 ? void 0 : _lists$slice.map((list, i) => /*#__PURE__*/React.createElement(StyledWrap, {
    key: list.label + i
  }, /*#__PURE__*/React.createElement(IconTooltip, {
    black: true,
    placement: "bottom-start",
    icon: /*#__PURE__*/React.createElement(StyledAvatar, {
      src: list.src,
      marginLeft: i == 0 ? 0 : marginLeft,
      onError: e => {
        if (e.currentTarget.src !== fallbackSrc) {
          e.currentTarget.src = fallbackSrc;
        }
      }
    }),
    content: /*#__PURE__*/React.createElement(Box, {
      key: list.label,
      whiteSpace: "nowrap"
    }, list.label),
    PopperProps: {
      sx: {
        '& .tooltip-content': {
          padding: '4px 5px !important'
        }
      }
    }
  }))), lists.length > showNumber && /*#__PURE__*/React.createElement(StyledLabelContainer, {
    canClick: plusClick,
    onClick: plusClick
  }, /*#__PURE__*/React.createElement(IconTooltip, {
    black: true,
    placement: "bottom-start",
    icon: /*#__PURE__*/React.createElement(Box, {
      sx: {
        fontSize: 12
      }
    }, "+", lists.length - showNumber),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, lists.slice(showNumber, showNumber + 10).map((list, index) => /*#__PURE__*/React.createElement(Box, {
      key: list.label + index,
      whiteSpace: "nowrap"
    }, list.label)), lists.length > showNumber + 10 && /*#__PURE__*/React.createElement(Box, {
      fontSize: 10,
      color: "#A5A5A5",
      lineHeight: "20px"
    }, "...and more"))
  })));
};
AvatarList.propTypes = {
  lists: PropTypes.shape({}),
  marginLeft: PropTypes.string,
  showNumber: PropTypes.number,
  plusClick: PropTypes.func,
  fallbackSrc: PropTypes.string
};
AvatarList.defaultProps = {
  lists: [],
  marginLeft: '-6px',
  showNumber: 5,
  plusClick: null,
  fallbackSrc: ''
};
var AvatarList$1 = AvatarList;
export { AvatarList$1 as default };